// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgencyFiltersController from "./agency_filters_controller"
application.register("agency-filters", AgencyFiltersController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScrollToErrorsController from "./scroll_to_errors_controller"
application.register("scroll-to-errors", ScrollToErrorsController)
